/**
 * 납품 전 QA React Query 훅.
 *
 * - ``useJobQa(jobId)`` — 작업 단위. CSV 다운로드 섹션에서 게이트에 사용.
 * - ``useRequestQa(requestId)`` — 의뢰 단위.
 *
 * 검수/수정 후 값이 바뀔 수 있으므로 staleTime 을 짧게 둔다.
 */

import { useQuery } from "@tanstack/react-query";

import { getJobQa, getRequestQa, type QaReport } from "@/lib/api/qa";

export function useJobQa(jobId: string, enabled = true) {
  return useQuery<QaReport>({
    queryKey: ["job-qa", jobId],
    queryFn: () => getJobQa(jobId),
    enabled: enabled && !!jobId,
    staleTime: 10_000,
  });
}

export function useRequestQa(requestId: string, enabled = true) {
  return useQuery<QaReport>({
    queryKey: ["request-qa", requestId],
    queryFn: () => getRequestQa(requestId),
    enabled: enabled && !!requestId,
    staleTime: 10_000,
  });
}
